export const messages = {
    "wr-dashboard.search.input.hint": "Arama",
    "wr-dashboard.search.label.breadcrumb": "Arama sonuçları",
    "wr-dashboard.search.message.empty": "Aramanızla eşleşen öğe yok",
    "wr-dashboard.side-bar.selected.title:plural": "{count} öğe seçildi | {count} öğe seçildi | {count} öğe seçildi",
    "wr-dashboard.side-bar.backup-type.disk": "Disk",
    "wr-dashboard.side-bar.backup-type.file": "Dosya",
    "wr-dashboard.side-bar.backup-type.notarized": "Tasdiklenmiş dosyalar ve klasörler",
    "wr-dashboard.side-bar.backup-type.exchange": "Uygulama - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Uygulama - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Uygulama - Sistem durumu",
    "wr-dashboard.side-bar.backup-type.application": "Uygulama",
    "wr-dashboard.backups-table.column.name": "Ad",
    "wr-dashboard.backups-table.column.size": "Boyut",
    "wr-dashboard.backups-table.column.version": "Son sürüm",
    "wr-dashboard.backups-table.action.delete": "Sil",
    "wr-dashboard.backups-table.message.no-backups": "Bulutta henüz hiç yedekleme yok",
    "wr-dashboard.backups-sidebar.label.size": "Boyut",
    "wr-dashboard.backups-sidebar.label.type": "Tür",
    "wr-dashboard.backups-sidebar.label.version": "Son sürüm",
    "wr-dashboard.backups-sidebar.label.created": "Oluşturulma",
    "wr-dashboard.backups-sidebar.label.machine": "Makine",
    "wr-dashboard.backups-sidebar.label.owner": "Sahip",
    "wr-dashboard.content-table.column.name": "Ad",
    "wr-dashboard.content-table.column.versions": "Sürümler",
    "wr-dashboard.content-table.column.volumes": "Birimler",
    "wr-dashboard.content-table.column.path": "Yol",
    "wr-dashboard.content-table.column.size": "Boyut",
    "wr-dashboard.content-table.column.version": "Son sürüm",
    "wr-dashboard.content-table.action.notary-verify": "Doğrula",
    "wr-dashboard.content-table.action.notary-get-crt": "Sertifika al",
    "wr-dashboard.content-table.action.asign": "İmzaya gönder",
    "wr-dashboard.content-table.action.versions": "Sürümler",
    "wr-dashboard.content-table.action.restore": "İndir",
    "wr-dashboard.content-table.label.size": "Boyut",
    "wr-dashboard.content-table.label.created": "Oluşturulma",
    "wr-dashboard.content-table.label.modified": "Değiştirildi",
    "wr-dashboard.content-table.message.empty-folder": "Bu klasör boş",
    "wr-dashboard.password-dialog-box.title.backup": "Şifreli yedekleme",
    "wr-dashboard.password-dialog-box.title.archive": "Şifreli arşiv",
    "wr-dashboard.password-dialog-box.message.backup": "{displayName} yedeklemesine erişmek için lütfen parola belirtin",
    "wr-dashboard.password-dialog-box.message.archive": "{displayName} arşivine erişmek için lütfen parola belirtin",
    "wr-dashboard.password-dialog-box.hint.password": "Parola",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Parola hatalı",
    "wr-dashboard.form.button.open": "Aç",
    "wr-dashboard.form.button.close": "Kapat",
    "wr-dashboard.form.button.cancel": "İptal",
    "wr-dashboard.form.button.continue": "Devam et",
    "wr-dashboard.form.button.proceed": "Devam",
    "wr-dashboard.form.button.delete": "Sil",
    "wr-dashboard.form.button.done": "Bitti",
    "wr-dashboard.form.button.retry": "Yeniden dene",
    "wr-dashboard.notary.verify.view.status.downloading": "İndiriliyor...",
    "wr-dashboard.notary.verify.view.status.validating": "Doğrulanıyor...",
    "wr-dashboard.notary.verify.view.status.pending": "Bekleyen sertifika...",
    "wr-dashboard.notary.verify.view.status.fail": "Sertifika eşleşmiyor...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Sertifika al",
    "wr-dashboard.notary.verify.view.file-info.name": "AD",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "İMZALAYAN:",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "YEDEKLEME TARİHİ",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "TASDİKLENME TARİHİ",
    "wr-dashboard.notary.verify.view.button.cancel": "İptal",
    "wr-dashboard.notary.verify.view.button.done": "Bitti",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Desteklenmeyen tarayıcı sürümü",
    "wr-dashboard.versions-dialog-box.title": "{fileName} sürümleri",
    "wr-dashboard.asign-dialog-box.title": "İmzaya gönder",
    "wr-dashboard.asign-dialog-box.message": "Dosya sürümü paylaşıldı ancak dosyanın bağlantısı olmadan kimse görüntüleyemez. İmza sahiplerini eklemek ve bağlantıyı paylaşmak için ASign'a gidin.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Dosya ayrıntılarını göster",
    "wr-dashboard.page-not-found.title": "Sayfa bulunamadı",
    "wr-dashboard.page-not-found.message.main": "Aradığınız sayfa bulunamadı.",
    "wr-dashboard.page-not-found.message.description": "Bağlantının süresi geçmiş ya da adresi hatalı yazmış olabilirsiniz.",
    "wr-dashboard.page-not-found.message.error": "Hata kodu: 404",
    "wr-dashboard.server-error.title": "Sunucu kullanılamıyor",
    "wr-dashboard.server-error.message": "Sunucu, şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin.",
    "wr-dashboard.server-error.message.error": "Hata kodu: 500",
    "wr-dashboard.account-menu.action.sign-out": "Oturumu kapat",
    "wr-dashboard.breadcrumb.item.machines": "Makineler",
    "wr-dashboard.breadcrumb.item.failed-backups": "Başarısız yedeklemeler",
    "wr-dashboard.machines-table.column.name": "Ad",
    "wr-dashboard.machines-table.column.size": "Boyut",
    "wr-dashboard.machines-table.message.no-machines": "Bulutta henüz hiç makine yok",
    "wr-dashboard.incomplete-backups.message.status:plural": "{size} depolama alanı kullanan {count} başarısız veya tamamlanmamış yedeklemeniz var | {size} Depolama alanı kullanan {count} başarısız veya tamamlanmamış yedeklemeniz var | {size} depolama alanı kullanan {count} başarısız veya tamamlanmamış yedeklemeniz var",
    "wr-dashboard.incomplete-backups.button.view": "Yedeklemeleri görüntüle",
    "wr-dashboard.incomplete-backups.button.delete": "Yedeklemeleri sil",
    "wr-dashboard.machines-table.message.space-used:plural": "Toplam yedekleme boyutu: {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Arşivleri sil",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Tamamlanmamış arşivleri sil",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Tamamlanmamış tüm arşivleri sil",
    "wr-dashboard.delete-archive.message": "Seçili arşivleri tüm konumlardan kalıcı olarak silmek istediğinizden emin misiniz? Tüm veriler silinecek ve geri alınamayacaktır.",
    "wr-dashboard.delete-archive.deletion-warning-message": "Bu web veri geri yükleme konsolunda yapılan değişiklikler, iş yükü çevrimiçi değilse veya değişiklikleri işlemek için herhangi bir aracı çevrimiçi değilse koruma konsolunun ilgili iş yüküne görsel olarak yansıtılmayabilir",
    "wr-dashboard.delete-archive.locked-error-message": "Arşiv, veri tutarlılığını sağlamak üzere kilitlendi. Lütfen arşiv ile ilgili tüm işlemleri (ör. tarama, geri yükleme, yedekleme) sonlandırın ve tekrar deneyin.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Sertifika beklemede",
    "wr-dashboard.certificate-pending-dialog-box.message": "Lütfen birkaç dakika içinde tekrar deneyin.",
    "wr-dashboard.form.button.ok": "Tamam"
};
